"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.CnEllipsis = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
require("cn-next/es/balloon/style");
var _balloon = _interopRequireDefault(require("cn-next/es/balloon"));
var React = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["children", "className", "ellipsisPosition", "endCharCount", "hasTooltip", "tooltipProps"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var Tooltip = _balloon["default"].Tooltip;
var CnEllipsis = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(CnEllipsis, _React$Component);
  function CnEllipsis(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.textRef = void 0;
    _this.onMouseEnter = function () {
      if (_this.textRef && _this.textRef.scrollWidth > _this.textRef.offsetWidth) {
        _this.setState({
          isOverflow: true
        });
      } else {
        _this.setState({
          isOverflow: false
        });
      }
    };
    _this.saveTextRef = function (ref) {
      _this.textRef = ref;
    };
    _this.state = {
      isOverflow: false
    };
    return _this;
  }
  var _proto = CnEllipsis.prototype;
  _proto.componentDidMount = function componentDidMount() {
    if (this.props.ellipsisPosition === 'middle') {
      if (this.textRef && this.textRef.scrollWidth > this.textRef.offsetWidth) {
        this.setState({
          isOverflow: true
        });
      }
    }
  };
  _proto.render = function render() {
    var _cx;
    var isOverflow = this.state.isOverflow;
    var _this$props = this.props,
      children = _this$props.children,
      className = _this$props.className,
      ellipsisPosition = _this$props.ellipsisPosition,
      endCharCount = _this$props.endCharCount,
      hasTooltip = _this$props.hasTooltip,
      tooltipProps = _this$props.tooltipProps,
      otherProps = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, _excluded);
    var classes = (0, _classnames["default"])((_cx = {
      'cn-ui-ellipsis': true
    }, _cx[className] = !!className, _cx));

    // 默认
    var trigger = /*#__PURE__*/React.createElement("div", (0, _extends2["default"])({
      onMouseEnter: this.onMouseEnter,
      className: classes
    }, otherProps), /*#__PURE__*/React.createElement("div", {
      ref: this.saveTextRef,
      className: "cn-ui-ellipsis-header"
    }, children));

    // 省略号出现在中间
    if (isOverflow && ellipsisPosition === 'middle') {
      var childrenStr = "" + children;
      var startChildren = childrenStr.substr(0, childrenStr.length - endCharCount);
      var endChildren = childrenStr.substr(-endCharCount);
      trigger = /*#__PURE__*/React.createElement("div", (0, _extends2["default"])({
        className: classes
      }, otherProps), /*#__PURE__*/React.createElement("div", {
        ref: this.saveTextRef,
        className: "cn-ui-ellipsis-header"
      }, startChildren), /*#__PURE__*/React.createElement("div", {
        className: "cn-ui-ellipsis-footer"
      }, endChildren));
    }

    // 出现 Balloon
    if (isOverflow && hasTooltip) {
      return /*#__PURE__*/React.createElement(Tooltip, (0, _extends2["default"])({
        trigger: trigger
      }, tooltipProps), children);
    }
    return trigger;
  };
  return CnEllipsis;
}(React.Component);
exports.CnEllipsis = CnEllipsis;
CnEllipsis.displayName = 'CnEllipsis';
CnEllipsis.defaultProps = {
  ellipsisPosition: 'end',
  endCharCount: 8,
  hasTooltip: true
};